import { render, staticRenderFns } from "./formCourseStep3.vue?vue&type=template&id=12270c89&"
import script from "./formCourseStep3.vue?vue&type=script&lang=js&"
export * from "./formCourseStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports